module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xQhwEG/tc-custom/9781035859580.jpg?1739848460573",
      "alt": "This image is the cover for the book Mabel Bean"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mabel Bean\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Mabel will take you behind the scenes of a Royal Palace. Watch her perform royal duties with surprising results! This clever, question-and- answer format allows groups of readers or even single readers to actively participate in Mabel Bean’s Royal Adventure. Mabel Bean is a scruffy, fluffy, curious dog who is always putting her nose into other people’s business. Join Mabel Bean on her adventure to London and experience royal life from a dog’s eye view!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Austin J. Stack\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Ireland, Austin moved to England where he met his wife of over thirty years. Throughout his life, Austin has owned a small holding, worked as a carer for additional needs adults, and used to run a wool shop in Devon. Austin began writing stories for his children, and the recent birth of his first Granddaughter has inspired him to pursue publishing his work.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0